import type { SVGProps } from "react";

type ProfileGlyphProps = SVGProps<SVGSVGElement>;

export const InfoGlyph = (props: ProfileGlyphProps) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.7" />
    <path
      d="M12 10.7v5.25"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <circle cx="12" cy="7.85" r="1.05" fill="currentColor" />
  </svg>
);

export const PencilGlyph = (props: ProfileGlyphProps) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      d="m5.45 16.88-.7 2.86 2.87-.68L18.7 7.98a1.63 1.63 0 0 0 0-2.31l-.37-.37a1.63 1.63 0 0 0-2.31 0Z"
      fill="currentColor"
    />
  </svg>
);

export const UserGlyph = (props: ProfileGlyphProps) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <circle cx="12" cy="8" r="3.2" stroke="currentColor" strokeWidth="1.85" />
    <path
      d="M5.8 19.25c.62-3.28 2.78-5.05 6.2-5.05s5.58 1.77 6.2 5.05"
      stroke="currentColor"
      strokeWidth="1.85"
      strokeLinecap="round"
    />
  </svg>
);

export const CalendarGlyph = (props: ProfileGlyphProps) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      d="M7.2 4.4v2.2M16.8 4.4v2.2M5.25 9.1h13.5M6.8 19.2h10.4a2 2 0 0 0 2-2V7.7a2 2 0 0 0-2-2H6.8a2 2 0 0 0-2 2v9.5a2 2 0 0 0 2 2Z"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DumbbellGlyph = (props: ProfileGlyphProps) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      d="M4.7 9.6v4.8M7.2 8.45v7.1M16.8 8.45v7.1M19.3 9.6v4.8M8.95 12h6.1"
      stroke="currentColor"
      strokeWidth="2.1"
      strokeLinecap="round"
    />
  </svg>
);

export const BodyGlyph = (props: ProfileGlyphProps) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      d="M12 6.7a1.9 1.9 0 1 0 0-3.8 1.9 1.9 0 0 0 0 3.8ZM4.95 8.65c2.3.9 4.65 1.34 7.05 1.34s4.75-.44 7.05-1.34M12 10.1v9.8M8.15 20.1l1.05-6.55M15.85 20.1l-1.05-6.55"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HeartGlyph = (props: ProfileGlyphProps) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      d="M3.6 12.05h3.45l1.7-3.2 2.6 6.7 1.8-3.5h7.25"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 20.15C7.75 17.55 4.05 14.1 4.05 9.9a4.2 4.2 0 0 1 7.6-2.45l.35.5.35-.5a4.2 4.2 0 0 1 7.6 2.45"
      stroke="currentColor"
      strokeWidth="1.65"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TrophyGlyph = (props: ProfileGlyphProps) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      d="M8 4.7h8v3.95a4 4 0 0 1-8 0ZM8 7H5.55a2.05 2.05 0 0 0 0 4.1H8M16 7h2.45a2.05 2.05 0 0 1 0 4.1H16M12 12.65v3.7M8.7 19.3h6.6M10.1 16.35h3.8"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowRightGlyph = (props: ProfileGlyphProps) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      d="m9.2 5.7 5.8 6.3-5.8 6.3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TelegramGlyph = (props: ProfileGlyphProps) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      d="M20.5 4.9 3.95 11.3c-.86.33-.83 1.56.04 1.85l4.06 1.35 1.58 4.7c.26.78 1.27.99 1.82.38l2.31-2.6 4.11 3.02c.69.51 1.68.12 1.83-.72l2.45-13.05c.17-.9-.8-1.66-1.65-1.33Z"
      fill="currentColor"
    />
  </svg>
);

export const InstagramGlyph = (props: ProfileGlyphProps) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <rect
      x="4.4"
      y="4.4"
      width="15.2"
      height="15.2"
      rx="4.4"
      stroke="currentColor"
      strokeWidth="1.85"
    />
    <circle cx="12" cy="12" r="3.45" stroke="currentColor" strokeWidth="1.85" />
    <circle cx="16.55" cy="7.55" r="1.15" fill="currentColor" />
  </svg>
);

export const VkGlyph = (props: ProfileGlyphProps) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      d="M13.05 17.4c-5.2 0-8.16-3.57-8.28-9.5h2.62c.09 4.35 2 6.2 3.5 6.58V7.9h2.47v3.76c1.48-.16 3.02-1.88 3.54-3.76h2.47a7.25 7.25 0 0 1-3.27 4.73 7.5 7.5 0 0 1 3.83 4.77h-2.72c-.57-1.8-1.97-3.2-3.85-3.39v3.39Z"
      fill="currentColor"
    />
  </svg>
);

export const HeadsetGlyph = (props: ProfileGlyphProps) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      d="M4.7 13.35v-1.2a7.3 7.3 0 0 1 14.6 0v1.2M7.55 17.4H6.8a2.1 2.1 0 0 1-2.1-2.1v-1.35a1.7 1.7 0 0 1 1.7-1.7h1.15Zm8.9 0h.75a2.1 2.1 0 0 0 2.1-2.1v-1.35a1.7 1.7 0 0 0-1.7-1.7h-1.15Zm0 0c-.62 1.35-1.86 2.03-3.72 2.03H11.5"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
